<template>
    <v-card color="#eee">
        <v-card-title
            class="text-xs-center justify-center primary--text"
            style="font-size: 1.8em; font-weight: 900;"
        >
            FRENTISTAS DO POSTO {{this.postoSelecionado.nome_fantasia.toUpperCase().replace('POSTO', '')}}
        </v-card-title>
        <v-card-text class="pt-0 mt-0">
            <v-layout justify-end class="mb-3">
                <v-flex xs1>
                    <v-tooltip bottom>
                        <v-btn
                            icon
                            color='primary'
                            dark
                            slot="activator"
                            @click="dialogCadastro = true"
                            class="ml-4"
                        >
                            <v-icon>add</v-icon>
                        </v-btn>
                        <span>Adicionar Frentista</span>
                    </v-tooltip>
                </v-flex>
            </v-layout>
            <v-layout
                align-start
                justify-center
                row wrap
                fill-height
                v-if="frentistas"
            >
                <v-flex xs12 sm12 md11>
                    <v-data-table
                        :headers="frentistasHeaders"
                        :items="frentistas"
                        hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.nome }}</td>
                            <td class="text-xs-left">{{ props.item.matricula || 'Não cadastrado' }}</td>
                            <td class="text-xs-center">
                                <v-layout align-center justify-center>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-switch
                                                color="success"
                                                v-on="on" value @click.stop="() => ativarGerente(props.item, props.index)" :input-value="props.item.gerente"></v-switch>
                                        </template>
                                        Habilite os gerentes
                                    </v-tooltip>
                                </v-layout>
                            </td>
                            <td class="text-xs-center">
                                <v-layout align-center justify-center>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-switch
                                                color="success"
                                                v-on="on"
                                                value
                                                @click.stop="() => ativarControlePrecos(props.item, props.index)"
                                                :input-value="props.item.controle_precos"
                                            ></v-switch>
                                        </template>
                                        Permite controlar preços
                                    </v-tooltip>
                                </v-layout>
                            </td>
                            <td class="text-xs-center">
                                <v-layout align-center justify-center>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-switch
                                                color="success"
                                                v-on="on"
                                                value
                                                @click.stop="
                                                    () => ativarControleFrentistas(props.item, props.index)"
                                                    :input-value="props.item.controle_frentistas"
                                                ></v-switch>
                                        </template>
                                        Permite controlar frentistas
                                    </v-tooltip>
                                </v-layout>
                            </td>
                            <td class="text-xs-center">
                                <v-layout align-center justify-center>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-switch
                                                color="success"
                                                v-on="on"
                                                value
                                                @click.stop="
                                                    () => ativarControleCashposto(props.item)"
                                                    :input-value="props.item.controle_cashposto"
                                                ></v-switch>
                                        </template>
                                        Permite venda de cashposto
                                    </v-tooltip>
                                </v-layout>
                            </td>
                            <td class="text-xs-center" style="width: 30px">
                                <v-layout align-center justify-center>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-checkbox
                                                class="mt-3 mb-0"
                                                color="primary"
                                                v-on="on"
                                                value
                                                @click.stop="() => !props.item.pessoa ? liberarAcesso(props.item) : false"
                                                :input-value="!!props.item.pessoa"
                                            ></v-checkbox>
                                        </template>
                                        {{ !props.item.pessoa ? 'Conceder acesso a este frentista' : 'Este frentista já possui acesso' }}
                                    </v-tooltip>
                                </v-layout>
                            </td>
                        <td class="text-xs-center justify-space-around" style="display: flex; flex-direction: row;">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        v-on="on"
                                        color="success"
                                        flat
                                        icon
                                        @click="frentistaSelecionado = props.item, mostrarSolicitacoes=true"
                                    >
                                        <v-icon :color="props.item.solicitacao_retirada.aberto? 'info': 'gray'">
                                            monetization_on
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Solicitações de retirada</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        v-on="on"
                                        flat
                                        icon
                                        @click="frentistaSelecionado=props.item, dialogConfirmacao=true"
                                    >
                                        <v-icon color="error">
                                            close
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Deletar Frentista</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                    v-on="on"
                                    icon
                                    flat
                                    color="info"
                                    @click="
                                        frentistaSelecionado = props.item,
                                        dialogEditarFrentista = true
                                    "
                                    >
                                    <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar Informações</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        v-on="on"
                                        flat
                                        icon
                                        @click="frentistaSelecionado = props.item, dialogDetalheFrentista = true"
                                    >
                                        <v-icon color="primary">
                                            remove_red_eye
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Vizualizar Solicitações</span>
                            </v-tooltip>
                        </td>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-pagination color="primary" circle v-model="pagination.page" :length="pages"></v-pagination>
        </v-card-actions>
        <v-dialog v-if="mostrarSolicitacoes" v-model="mostrarSolicitacoes" width="500">
            <solicitacoes-recebimento
                :cnpj="postoSelecionado.cnpj"
                :frentista="frentistaSelecionado"
                @fechar="mostrarSolicitacoes = false, frentistaSelecionado = null"
            />
        </v-dialog>
        <v-snackbar
            v-model="snackbar.active"
            :color="snackbar.color"
            :multi-line="snackbar.multiLine"
            :timeout="snackbar.timeout"
            :vertical="snackbar.vertical"
        >
            {{ snackbar.text }}
        <v-btn
            flat
            @click="snackbar.active = false"
        >
            Fechar
        </v-btn>
        </v-snackbar>
        <v-footer
            absolute
            class="mb-4 justify-center"
            color="#eee"
        >
            <v-btn
                class="mb-4"
                @click="$emit('fechar')"
                round
            >
                Fechar
            </v-btn>
        </v-footer>
        <v-dialog lazy v-model="dialogLiberarAcesso" width="400" :fullscreen="$vuetify.breakpoint.xs">
            <liberar-acesso-frentista :frentista="frentistaSelecionado" :posto="postoSelecionado" @complete="function () {
                carregarFrentistas()
                dialogLiberarAcesso = false
            }"></liberar-acesso-frentista>
        </v-dialog>
        <v-dialog v-model="dialogCadastro" width="400" :fullscreen="$vuetify.breakpoint.xs">
            <cad-frentista :posto="postoSelecionado" @complete="function () {
                carregarFrentistas()
                dialogCadastro = false
            }"></cad-frentista>
        </v-dialog>
        <v-dialog
            v-model="dialogEditarFrentista"
            v-if="dialogEditarFrentista"
            width="35em"
        >
            <editar-frentista
                :frentista="frentistaSelecionado"
                :posto="postoSelecionado"
                @fechar="
                dialogEditarFrentista = false,
                frentistaSelecionado = undefined,
                carregarFrentistas()
                "
                @carregar="carregarFrentistas"
            />
        </v-dialog>
        <v-dialog v-model="dialogDetalheFrentista" v-if="dialogDetalheFrentista" width="400" :fullscreen="$vuetify.breakpoint.xs">
            <detalhes-frentista :frentista="frentistaSelecionado" :posto="postoSelecionado" @fechar="dialogDetalheFrentista=false, frentistaSelecionado=undefined"/>
        </v-dialog>
        <v-dialog v-model="dialogConfirmacao" v-if="dialogConfirmacao" width="500" :fullscreen="$vuetify.breakpoint.xs">
            <confirmacao
                @negado="dialogConfirmacao=false, frentistaSelecionado=undefined"
                @aceito="removerFrentista"
                titulo="Você realmente deseja excluir esse frentista?"
                cor="error"
            />
        </v-dialog>
    </v-card>
</template>

<script>

import SolicitacoesRecebimento from '@/components/dialogs/SolicitacoesRecebimento'
import CadFrentista from '@/components/cadastros/CadFrentista'
import LiberarAcessoFrentista from '@/components/cadastros/LiberarAcessoFrentista'
import EditarFrentista from '@/components/dialogs/EditarFrentista'
import Confirmacao from '@/components/Confirmacao'
import DetalhesFrentista from '@/components/dialogs/DetalhesFrentista'

export default {
  props: ['postoSelecionado'],
  components: {
    SolicitacoesRecebimento,
    CadFrentista,
    LiberarAcessoFrentista,
    EditarFrentista,
    DetalhesFrentista,
    Confirmacao
  },
  data () {
    return {
      mostrarSolicitacoes: false,
      frentistaSelecionado: null,
      dialogEditarFrentista: false,
      dialogLiberarAcesso: false,
      dialogCadastro: false,
      dialogDetalheFrentista: false,
      dialogConfirmacao: false,
      frentistas: [],
      totalItens: 0,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      pagination: {
        rowsPerPage: 8,
        page: 1
      },
      frentistasHeaders: [
        {
          text: 'Nome',
          align: 'left',
          sortable: false,
          value: 'nome'
        },
        {
            text: 'Matrícula',
            sortable: false,
            value: 'matricula',
            align: 'left'
        },
        {
            text: 'Gerente',
            sortable: false,
            align: 'left'
        },
        {
            text: 'Preços',
            sortable: false,
            align: 'left'
        },
        {
            text: 'Admissão',
            sortable: false,
            align: 'left'
        },
        {
            text: 'CashPosto',
            sortable: false,
            align: 'left'
        },
        {
            text: 'Acesso',
            sortable: false,
            align: 'left'
        },
        {
          align: 'right',
          sortable: false
        }
      ]
    }
  },
  mounted () {
    if (this.postoSelecionado) {
        this.carregarFrentistas()
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItens == null
      ) return 0

      return Math.ceil(this.totalItens / this.pagination.rowsPerPage)
    }
  },
  watch: {
    pagination: {
      handler () {
        this.carregarFrentistas()
      },
      deep: true
    }
  },
  methods: {
    carregarFrentistas () {
        const data = {
            cnpj: this.postoSelecionado.cnpj,
            page: this.pagination.page
        }
        this.$store.dispatch('frentistaPosto', data).then(value => {
            this.frentistas = value.results
            this.totalItens = value.count
        }).catch(
            () => this.snackbarActive('Não foi possível pegar frentistas', 'error')
        )
    },
    snackbarActive (text, color) {
      this.snackbar.color = color
      this.snackbar.text = text
      this.snackbar.active = true
    },
    removerFrentista () {
      this.$store.dispatch('removerFrentista', {
        id: this.frentistaSelecionado.id_frentista,
        cnpj_posto: this.postoSelecionado.cnpj
      }).then(() => {
            this.carregarFrentistas()
            this.dialogConfirmacao = false
        })
    },
    ativarGerente (frentista) {
      if (!frentista.pessoa) {
        this.snackbarActive('Para ser gerente é necessário um acesso Apetrus', 'error')
          return
      }
      this.$store.dispatch('editarFrentista', {
        id_frentista: frentista.id_frentista,
        gerente: !frentista.gerente
      }).then(
        () => this.carregarFrentistas()
        ).catch((e) => {
        alert(e.message)
      })
    },
    ativarControlePrecos (frentista) {
      if (!frentista.pessoa) {
        this.snackbarActive('Para ser gerente é necessário um acesso Apetrus', 'error')
          return
      }
      this.$store.dispatch('editarFrentista', {
        id_frentista: frentista.id_frentista,
        controle_precos: !frentista.controle_precos
      }).then(() => this.carregarFrentistas()).catch((e) => {
        alert(e.message)
      })
    },
    ativarControleFrentistas (frentista) {
      if (!frentista.pessoa) {
        this.snackbarActive('Para ser gerente é necessário um acesso Apetrus', 'error')
          return
      }
      this.$store.dispatch('editarFrentista', {
        id_frentista: frentista.id_frentista,
        controle_frentistas: !frentista.controle_frentistas
      }).then(() => this.carregarFrentistas()).catch((e) => {
        alert(e.message)
      })
    },
    liberarAcesso (frentista) {
      this.frentistaSelecionado = frentista
      this.dialogLiberarAcesso = true
    },
    ativarControleCashposto (frentista) {
        this.$store.dispatch('editarFrentista', {
          id_frentista: frentista.id_frentista,
          controle_cashposto: !frentista.controle_cashposto
        }).then(() => this.carregarFrentistas()).catch((e) => {
            alert(e.message)
        })
    }
  }
}
</script>
